import Utils from '../utils/basic.utils'

const defaultGlobalConfig = {
  domainUrl: '/zwsk-boot',
  uploadUrl: '/zwsk-boot/upload',
  staticDomainUrl: '/zwsk-boot/static',
  http: {
    timeout: 20000 // 接口超时时间:
  },
  profiles: 'dev'
}

let zkGlobalConfig = window._CONFIG

// 全局配置如果存在, 则合并默认(不存在使用默认)
if (zkGlobalConfig) Utils.mergeObject(zkGlobalConfig, defaultGlobalConfig)
else zkGlobalConfig = defaultGlobalConfig // 不存在使用默认

if (process.env.VUE_APP_BASE_URL) {
  zkGlobalConfig.domainUrl = process.env.VUE_APP_BASE_URL
  zkGlobalConfig.staticDomainUrl = process.env.VUE_APP_BASE_URL + '/static'
}

if (process.env.VUE_APP_UPLOAD_URL) {
  zkGlobalConfig.uploadUrl = process.env.VUE_APP_UPLOAD_URL
}

if (process.env.VUE_APP_STATIC_URL) {
  zkGlobalConfig.staticDomainUrl = process.env.VUE_APP_STATIC_URL
}

if (process.env.NODE_ENV) {
  zkGlobalConfig.profiles = process.env.NODE_ENV
}

window._CONFIG = zkGlobalConfig
export default zkGlobalConfig
